import { createContext, useContext } from 'react';

/**
 * Screen recordings, owned by the app shell rather than the form or message
 * box that started them. Task forms use explicit draft keys; chats retain
 * conversation IDs. Finished recordings wait here until their destination
 * mounts again. The external portal has its own provider.
 *
 * The composer lives inside a ChatWindow keyed by conversation, so opening a
 * different chat unmounts it — and a recorder mounted there was torn down with
 * it, stopping the capture and dropping the take. Held here, a recording runs
 * across chat switches and page changes, and when it stops it is filed as a
 * draft against the conversation it was started in. That chat's composer
 * stages the draft the moment it is (or next is) on screen, so the file goes
 * to the person it was recorded for, never to whichever chat happened to be
 * open when Stop was pressed.
 *
 * Outside this provider useScreenRecording() is null; isolated consumers can
 * still use AttachMenu's inline recorder.
 */

// Kept apart from the provider (ScreenRecordingProvider.js) so the composer can
// read it without pulling in the router and the recorder UI.
export const ScreenRecordingContext = createContext(null);

export const useScreenRecording = () => useContext(ScreenRecordingContext);
